<template>
  <ScrollerContainer>
    <!-- <div class="placeholder" style="width: 100vw; background: #e3e3e3">
      <img src="/img/50-bg-2.jpg" />
    </div> -->
    <div class="container year-wrap">
      <div class="years">
        <div class="year-1974 year">1974</div>
        <div class="line-wrap"><div class="line"></div></div>
        <div class="year-2024 year">2024</div>
      </div>
    </div>
    <TextBlock>
      A track record of reliable data, analysis, policy recommendations, and
      real-world solutions to help create a secure and sustainable energy future
      for all
    </TextBlock>
    <IntroVideoSection />
    <TextBlock>
      Founded in response to the 1973-1974 oil crisis, the IEA remains
      laser-focused on energy security. At the same time, today's IEA has a
      wider mandate to focus on a broad range of energy issues, including
      climate change and decarbonisation, energy access and efficiency,
      investment and innovation, and ensuring reliable, affordable and
      sustainable energy for all.
    </TextBlock>
    <TimelineSection @handle-timeline="toggleTimeline" />
    <Timeline v-if="viewTimeline" @handle-timeline="toggleTimeline" />
    <!-- <TestimonialSection /> -->
    <!-- <div style="width: 100%; height: 600px"></div> -->
  </ScrollerContainer>
</template>

<script>
import ScrollerContainer from "./components/ScrollerContainer.vue";
import IntroVideoSection from "./components/IntroVideoSection.vue";
import TimelineSection from "./components/TimelineSection.vue";
import Timeline from "./components/Timeline.vue";
import TextBlock from "./components/TextBlock.vue";
// import TestimonialSection from "./components/TestimonialSection.vue";

export default {
  mounted() {},
  name: "App",
  components: {
    ScrollerContainer,
    IntroVideoSection,
    TimelineSection,
    Timeline,
    TextBlock,
    // TestimonialSection,
  },
  data() {
    return {
      viewTimeline: false,
    };
  },
  watch: {
    viewTimeline(value) {
      const wrapper = document.getElementsByTagName("html")[0];
      if (value) {
        wrapper.classList.add("modal-opened");
      } else {
        wrapper.classList.remove("modal-opened");
      }
    },
  },
  methods: {
    toggleTimeline() {
      this.viewTimeline = !this.viewTimeline;
    },
  },
};
</script>

<style>
body {
  margin: 0;
}
/* .year-2024 {
  transform: translateY(-);
} */
.year-wrap {
  padding-top: 100px;
}
.years {
  display: flex;
  flex-flow: column;
  justify-content: space-between;
}
.line-wrap {
  padding: 16px 0;
  height: 8vh;
  box-sizing: border-box;
}
.line {
  position: relative;
  border: 1px solid #e3e3e3;
  width: 1px;
  height: 100%;
  margin: 0 auto;
}
.year {
  color: #04f;
  font-size: 5.25rem;
  line-height: 5.25rem;
  letter-spacing: -0.03em;
  font-weight: 700;
  text-align: center;
}
.year-1974 {
  color: #e3e3e3;
}
.placeholder {
  position: relative;
}
.placeholder img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  object-fit: cover;
}
.modal-opened {
  overflow-y: hidden;
}
@media screen and (min-width: 1480px) {
  .placeholder {
    height: 760px;
  }
}
@media screen and (min-width: 1280px) and (max-width: 1479px) {
  .placeholder {
    height: 760px;
  }
}
@media screen and (min-width: 960px) and (max-width: 1279px) {
  .placeholder {
    height: 612px;
  }
}
@media screen and (min-width: 730px) and (max-width: 959px) {
  .placeholder {
    height: 568px;
  }
}
@media screen and (max-width: 729px) {
  .placeholder {
    height: 416px;
  }
}
</style>
